import { ElementType, FC, ReactNode } from 'react'
import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'
import { useLinkCustomerToService } from './useLinkCustomerToService'
import { UnlinkCustomerModal } from '../UnlinkCustomerModal'
import { LinkCustomerModal } from '../LinkCustomerModal'
import { LinkEntityWidget } from '../../LinkEntityWidget'
import { usePermissions } from 'lib/rbac'

export const LinkCustomerToServiceWidget: FC<{
  entityIcon?: ReactNode
  externalEntityLabel: string
  sequenceEntityLabel: string
  customerId: string
  service: IntegrationServices
  canUnlink?: boolean
  canLink?: boolean
  noLinkFoundText?: string
  linkModal?: ElementType<{
    customerId: string
    service: IntegrationServices
    onClose: () => void
  }>
  linkModalProps?: Record<string, unknown>
  unlinkModal?: ElementType<{
    customerId: string
    service: IntegrationServices
    onClose: () => void
  }>
  hideWhenNoLink?: boolean
  showLinkButton?: boolean
  showUnlinkButton?: boolean
}> = props => {
  const { can } = usePermissions()
  const canUpdateCustomer = can('org.customer:update')

  const effectiveCanLink = props.canLink ?? canUpdateCustomer
  const effectiveCanUnlink = props.canUnlink ?? canUpdateCustomer

  const hasCustomer = Boolean(props.customerId)

  const hook = useLinkCustomerToService({
    customerId: props.customerId,
    service: props.service,
    canUnlink: effectiveCanUnlink,
    enabled: hasCustomer
  })

  if (props.hideWhenNoLink && !hook.linkedAccount.value) {
    return null
  }

  const LinkModal = props.linkModal ?? LinkCustomerModal
  const UnlinkModal = props.unlinkModal ?? UnlinkCustomerModal

  return (
    <LinkEntityWidget
      data-testid={`${props.service}.linkCustomer`}
      canLink={effectiveCanLink}
      externalEntityLabel={props.externalEntityLabel}
      sequenceEntityLabel={props.sequenceEntityLabel}
      isLoaded={hasCustomer ? hook.isLoaded : true}
      serviceName={hook.serviceName}
      linkedAccount={hook.linkedAccount.value ? hook.linkedAccount : null}
      noLinkFoundText={props.noLinkFoundText}
      showLinkButton={hasCustomer}
      showUnlinkButton={props.showUnlinkButton}
      linkModal={({ onClose }) => (
        <LinkModal
          customerId={props.customerId}
          service={props.service}
          onClose={onClose}
          {...(props.linkModalProps ?? {})}
        />
      )}
      unlinkModal={({ onClose }) => (
        <UnlinkModal
          customerId={props.customerId}
          service={props.service}
          onClose={onClose}
        />
      )}
    />
  )
}
